let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e5d3H")).then(() => parcelRequire('fJhua'));